import { Box, Typography, Card, CardContent } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ModernCard from "./ModernCard";
import PropTypes from "prop-types";

const ChecklistsCard = ({ checklistObjects, onViewChecklist, t }) => (
  <ModernCard
    title={t("documentDetail.checklistsTitle")}
    icon={AssignmentIcon}
    color="info"
  >
    {checklistObjects.length > 0 ? (
      <Grid container spacing={2}>
        {checklistObjects.map((checklist) => (
          <Grid key={checklist.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card
              variant="outlined"
              sx={{
                cursor: "pointer",
                borderRadius: 2,
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  boxShadow: 4,
                  transform: "translateY(-2px)",
                  borderColor: "primary.main",
                },
              }}
              onClick={() => onViewChecklist(checklist)}
            >
              <CardContent sx={{ textAlign: "center", p: 2 }}>
                <AssignmentIcon
                  sx={{ fontSize: 32, color: "primary.main", mb: 1 }}
                />
                <Typography variant="subtitle1" fontWeight="bold">
                  {checklist.name || t("documentDetail.na")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    ) : (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <AssignmentIcon sx={{ fontSize: 48, color: "text.disabled", mb: 2 }} />
        <Typography variant="body2" color="text.secondary">
          {t("documentDetail.noChecklistsAttached")}
        </Typography>
      </Box>
    )}
  </ModernCard>
);

ChecklistsCard.propTypes = {
  checklistObjects: PropTypes.array.isRequired,
  onViewChecklist: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default ChecklistsCard;
